import { Link, useNavigate } from "react-router-dom";
import path from "../../utils/path";
import LogoSrc from "../../assets/logo.svg";
import "./Logo.module.css";
import type { ClassAttributes, ImgHTMLAttributes } from "react";
import type { JSX } from "react/jsx-runtime";
import { useAuth } from "../../providers/AuthProvider";

export default function Logo(
  props: JSX.IntrinsicAttributes &
    ClassAttributes<HTMLImageElement> &
    ImgHTMLAttributes<HTMLImageElement>
) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!isAuthenticated) { window.location.href = "https://thegiftsclub.io"; return; }
    navigate(path.root);
  };

  return (
    <Link to="#" onClick={handleClick} style={props.style}>
      <img src={LogoSrc} alt="The gifts club logo" />
    </Link>
  );
}
